import checkSuccessIcon from '@assets/icons/check-success.svg';
import errorIcon from '@assets/icons/error.svg';
import warningIcon from '@assets/icons/warning.svg';

export enum SnackbarType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning'
}

export const snackbarTypes = {
  success: {
    color: 'var(--green-1)',
    icon: checkSuccessIcon
  },
  error: {
    color: 'var(--red-3)',
    icon: errorIcon
  },
  warning: {
    color: 'var(--yellow-1)',
    icon: warningIcon
  }
};
